export const companyBenefitStatus = {
	0: "Pending",
	1: "Enabled",
	2: "Disabled"
};
